import paymentClient from '../services/http-client';
import { createModuleQueryKeys } from '../../createModuleQueryKeys';
import { useModuleQuery } from '../../useModuleQuery';
import type { PaymentsResponse, GatewayStatusResponse } from './interfaces';

export const paymentModuleKeys = {
  ...createModuleQueryKeys('payment-module'),
  payments: (clientId: string | null) => [...paymentModuleKeys.all(clientId), 'payments'] as const,
  paymentByToken: (clientId: string | null, token: string) => [...paymentModuleKeys.payments(clientId), 'token', token] as const,
  gatewayStatus: (clientId: string | null, token: string) => [...paymentModuleKeys.payments(clientId), 'gateway-status', token] as const
};

/** GET /payment, optionally auto-refreshing every `refetchInterval` ms. */
export const usePaymentModulePaymentsQuery = (refetchInterval: number | false = false) =>
  useModuleQuery({
    queryKey: paymentModuleKeys.payments,
    request: () => paymentClient.get<PaymentsResponse>('payment'),
    staleTime: 0,
    refetchOnMount: 'always',
    refetchInterval
  });

/** GET /payment/{token}/gateway-status - Check transaction status from gateway */
export const usePaymentGatewayStatusQuery = (token: string | null | undefined) =>
  useModuleQuery({
    queryKey: (clientId) => paymentModuleKeys.gatewayStatus(clientId, token ?? ''),
    request: () => paymentClient.get<GatewayStatusResponse>(`/payment/${token}/gateway-status`),
    enabled: !!token,
    staleTime: 0
  });
